import { render } from "./MobileSecondaryMenu.vue?vue&type=template&id=7c39ce31"
import script from "./MobileSecondaryMenu.vue?vue&type=script&lang=js"
export * from "./MobileSecondaryMenu.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7c39ce31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c39ce31', script)) {
    api.reload('7c39ce31', script)
  }
  
  module.hot.accept("./MobileSecondaryMenu.vue?vue&type=template&id=7c39ce31", () => {
    api.rerender('7c39ce31', render)
  })

}

script.__file = "src/components/menu/MobileSecondaryMenu.vue"

export default script